import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorResponse } from 'src/app/models/error.model';
import { MedioPagoCalculadora } from 'src/app/models/medio-pago-calculadora.model';
import { MediosPagoCalculadoraService } from 'src/app/services/medios-pago-calculadora.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-edit-medio-pago',
    templateUrl: './edit-medio-pago.component.html',
    styleUrls: ['./edit-medio-pago.component.scss']
})
export class EditMedioPagoComponent implements OnInit {

    medioPago?: MedioPagoCalculadora;

    form = new UntypedFormGroup({
        nombre: new UntypedFormControl('', [Validators.required]),
        clave: new UntypedFormControl(null),
        cuotas: new UntypedFormControl(1, [Validators.required, Validators.min(1)]),
        coeficienteAjuste: new UntypedFormControl(null, [Validators.required]),
        costoCobro: new UntypedFormControl(null, [Validators.required]),
        aplicaIva: new UntypedFormControl(false, [Validators.required]),
        iva: new UntypedFormControl(null),
        sirtac: new UntypedFormControl(null, [Validators.required]),
        iibb: new UntypedFormControl(null, [Validators.required]),
        cyd: new UntypedFormControl(null, [Validators.required]),
        costoInt: new UntypedFormControl(null),
        activo: new UntypedFormControl(true, [Validators.required])
    });

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private mediosPagoService: MediosPagoCalculadoraService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params?.id) {
                this.mediosPagoService.getMedioPagoById(params.id).subscribe({
                    next: medio => {
                        this.medioPago = medio;
                        this.form.setValue({
                            nombre: medio.nombre,
                            clave: medio.clave ?? null,
                            cuotas: medio.cuotas,
                            coeficienteAjuste: medio.coeficienteAjuste,
                            costoCobro: medio.costoCobro,
                            aplicaIva: medio.aplicaIva,
                            iva: medio.iva ?? null,
                            sirtac: medio.sirtac,
                            iibb: medio.iibb,
                            cyd: medio.cyd,
                            costoInt: medio.costoInt ?? null,
                            activo: medio.activo
                        });
                    },
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener el medio de pago', error.error?.descripcion)
                });
            }
        });
    }

    get aplicaIva(): boolean {
        return this.form.value.aplicaIva === true;
    }

    save() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        const v = this.form.value;
        const payload: MedioPagoCalculadora = {
            nombre: v.nombre,
            clave: v.clave?.trim() || null,
            cuotas: v.cuotas,
            coeficienteAjuste: v.coeficienteAjuste,
            costoCobro: v.costoCobro,
            aplicaIva: v.aplicaIva,
            iva: this.aplicaIva ? v.iva : 0,
            sirtac: v.sirtac,
            iibb: v.iibb,
            cyd: v.cyd,
            costoInt: v.costoInt ?? null,
            activo: v.activo
        };
        if (this.medioPago) {
            this.mediosPagoService.updateMedioPago({ ...payload, id: this.medioPago.id }).subscribe({
                next: () => {
                    this.utilsService.alert('Medio de pago actualizado', `"${payload.nombre}" fue actualizado correctamente.`);
                    this.navigateBack();
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al actualizar', error.error?.descripcion)
            });
        } else {
            this.mediosPagoService.createMedioPago(payload).subscribe({
                next: () => {
                    this.utilsService.alert('Medio de pago creado', `"${payload.nombre}" fue creado correctamente.`);
                    this.navigateBack();
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al crear', error.error?.descripcion)
            });
        }
    }

    cancel() {
        this.navigateBack();
    }

    private navigateBack() {
        this.router.navigate(['configuracion', 'calculadora', 'medios-de-pago']);
    }
}
